import { SignUp } from "@clerk/clerk-react";

export default function SignUpPage() {
  return (
    <main className="min-h-screen w-full flex items-center justify-center bg-lucid-deep px-6 py-10">
      <SignUp routing="path" path="/sign-up" signInUrl="/sign-in" afterSignUpUrl="/play" />
    </main>
  );
}
